import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { forwardRef } from 'react';
import LoadingSpinner from '../../../loading-spinner';
import type { ButtonSize, ButtonVariant } from '../../split-button.types';
type MainButtonProps = {
  children: React.ReactNode;
  disabled: boolean;
  loading?: boolean;
  loadingAriaLabel?: string;
  onClick?: () => void;
  size?: ButtonSize;
  type?: 'button' | 'submit' | 'reset';
  variant?: ButtonVariant;
};
const MainButton = forwardRef<HTMLButtonElement, MainButtonProps>((t0, ref) => {
  const $ = _c(14);
  const {
    children,
    disabled,
    loading: t1,
    loadingAriaLabel: t2,
    onClick,
    size: t3,
    type: t4,
    variant: t5
  } = t0;
  const loading = t1 === undefined ? false : t1;
  const loadingAriaLabel = t2 === undefined ? "Loading" : t2;
  const size = t3 === undefined ? "default" : t3;
  const type = t4 === undefined ? "button" : t4;
  const variant = t5 === undefined ? "secondary" : t5;
  const t6 = size ?? "compact";
  let t7;
  if ($[0] !== children || $[1] !== loading || $[2] !== loadingAriaLabel || $[3] !== variant) {
    t7 = <div className="flex items-center justify-center">{loading ? <LoadingSpinner ariaLabel={loadingAriaLabel} color={variant === "primary" ? "quinary" : "primary"} /> : <span className="inline-block overflow-hidden text-ellipsis whitespace-nowrap">{children}</span>}</div>;
    $[0] = children;
    $[1] = loading;
    $[2] = loadingAriaLabel;
    $[3] = variant;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== disabled || $[6] !== loading || $[7] !== onClick || $[8] !== ref || $[9] !== t6 || $[10] !== t7 || $[11] !== type || $[12] !== variant) {
    t8 = <button className="fp-button fp-split-main fp-custom-appearance text-label-2" data-size={t6} data-variant={variant} data-loading={loading} disabled={disabled} onClick={onClick} ref={ref} tabIndex={0} type={type}>{t7}</button>;
    $[5] = disabled;
    $[6] = loading;
    $[7] = onClick;
    $[8] = ref;
    $[9] = t6;
    $[10] = t7;
    $[11] = type;
    $[12] = variant;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
});
export default MainButton;